/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Stepper({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#Stepper_svg__a)"><path d="M6.9 3a.6.6 0 0 1 .6-.6h7a.6.6 0 1 1 0 1.2h-7a.6.6 0 0 1-.6-.6M6.9 13a.6.6 0 0 1 .6-.6h7a.6.6 0 1 1 0 1.2h-7a.6.6 0 0 1-.6-.6M6.9 8a.6.6 0 0 1 .6-.6h7a.6.6 0 1 1 0 1.2h-7a.6.6 0 0 1-.6-.6" /><path fillRule="evenodd" d="M.3 2.9a2.1 2.1 0 1 1 4.2 0 2.1 2.1 0 0 1-4.2 0M2.4 2a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8M.3 13a2.1 2.1 0 1 1 4.2 0 2.1 2.1 0 0 1-4.2 0m2.1-.9a.9.9 0 1 0 0 1.8.9.9 0 0 0 0-1.8" clipRule="evenodd" /><path d="M2.4 4.3a.6.6 0 0 1 .6.6v6a.6.6 0 1 1-1.2 0v-6a.6.6 0 0 1 .6-.6" /></g><defs><clipPath id="Stepper_svg__a"><path fill="red" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;